var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has-text-centered section-title"},[(_vm.imgName)?_c('span',{staticClass:"section-title--icon"},[_c('i',{class:_vm.imgName})]):(_vm.stairs)?_c('span',[_c('img',{attrs:{"src":require("../assets/icons/Stairs_icon.png"),"alt":"stairs logo"}})]):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }